
import createInlineToolbarPlugin from './createInlineToolbarPlugin'

export default createInlineToolbarPlugin
